import styled from 'styled-components';

export const SOptionsRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  width: 100%;
`;

export const SOptionCard = styled.button`
  flex: 1 1 0;
  min-width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 16px 12px;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  background-color: ${({ theme, selected }) =>
    selected ? theme.palette.colors.gray100 : theme.palette.colors.white};
  border: 1px solid
    ${({ theme, selected }) =>
      selected ? theme.palette.primary.main : theme.palette.colors.gray200};
  border-radius: 6px;
  opacity: ${({ disabled }) => (disabled ? 0.5 : 1)};
  transition: border-color 0.15s ease, background-color 0.15s ease;

  :hover {
    border-color: ${({ theme, disabled }) =>
      disabled ? theme.palette.colors.gray200 : theme.palette.primary.main};
  }
`;

export const SOptionCode = styled.span`
  font-weight: 700;
  font-size: 18px;
  color: ${({ theme, selected }) =>
    selected ? theme.palette.primary.main : theme.palette.colors.gray400};
`;

export const SOptionLabel = styled.span`
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  color: ${({ theme }) => theme.palette.text.primary};
`;
